module.exports = __webpack_public_path__ + "static/img/logo2.9faf5de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo2.png
// module id = 8isl
// module chunks = 1